var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 11.264c0-.743-.073-1.51-.196-2.229H11.217v4.242h6.064a4.996 4.996 0 0 1-2.25 3.33l3.62 2.757c2.126-1.941 3.349-4.77 3.349-8.1z",
    fill: "#4280EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.217 22c3.032 0 5.575-.983 7.433-2.66l-3.619-2.732c-1.002.671-2.298 1.054-3.814 1.054-2.934 0-5.404-1.94-6.308-4.529l-3.717 2.804C3.099 19.65 6.962 22 11.217 22z",
    fill: "#34A353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.909 13.11a6.556 6.556 0 0 1 0-4.219L1.192 6.063a10.819 10.819 0 0 0 0 9.874l3.717-2.828z",
    fill: "#F6B704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.217 4.362a6.192 6.192 0 0 1 4.303 1.654l3.204-3.164C16.694.983 14.004-.024 11.217 0 6.962 0 3.099 2.35 1.192 6.063l3.717 2.828c.904-2.612 3.374-4.529 6.308-4.529z",
    fill: "#E54335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.17bb26aba2e6f220bb50ac3cd49d1ec1.svg";
export { ForwardRef as ReactComponent };